
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { HeraBaseService, ISupportPlatform } from "./HeraBaseService";

export interface ISupportCategory {
    name: string;
    language: string;
    external_id: string;
    description: string;
    platform_id: string;
    icon_location: string;
    platform: ISupportPlatform;
}

export class SupportCategoryService extends HeraBaseService {

    protected static instance: SupportCategoryService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportCategoryService.instance) SupportCategoryService.instance = new SupportCategoryService();
        return SupportCategoryService.instance;
    }

    queryCategories(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ISupportCategory>> {
        params["platform.platform_id"] = params.platform_id;
        delete params.platform_id;
        return this.report(this.transport.get("/hera/api/v1/support/category", { query: this.normalizeParams(params) }));
    }

    createSupportCategory(supportCategory: Partial<ISupportCategory>): Promise<SanitizedResponse<ISupportCategory>> {
        return this.report(this.transport.post("/hera/api/v1/support/category", supportCategory));
    }

    updateSupportCategory(supportCategory: Partial<ISupportCategory>): Promise<SanitizedResponse<ISupportCategory>> {
        return this.report(this.transport.patch(`/hera/api/v1/support/category/${supportCategory.external_id}`, supportCategory));
    }

    deleteSupportCategory(id: string): Promise<SanitizedResponse<ISupportCategory>> {
        return this.report(this.transport.delete(`/hera/api/v1/support/category/${id}`));
    }

}

